import apiSlice from "../../app/api/apiSlice";

export const offersApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCarrierRelatedCargos: builder.query({
			query: (token) => `/api/carrierCargos?token=${token}`,
			providesTags: [{ type: "CarrierCargos", id: "LIST" }],
		}),
		addOffer: builder.mutation({
			query: ({ token, cargoId, price }) => ({
				url: `/api/cargo/addOffer`,
				method: "POST",
				body: { token, cargoId, price },
			}),
			invalidatesTags: [{ type: "CarrierCargos", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const { useGetCarrierRelatedCargosQuery, useAddOfferMutation } =
	offersApiSlice;
